import { styled } from '@mui/material/styles';
import { Toolbar } from '@mui/material';

export const StyledRoot = styled(Toolbar)(({ theme }) => ({
    height: 48,
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: theme.palette.background.neutral,
    padding: theme.spacing(0, 1, 0, 3)
}));
